import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../App.css';
import { cardOperatorLogos } from '../Utilities/Placeholders';
import { CreditCard, Edit } from '@mui/icons-material';

function CardTile({ cardNumber, isSelected, isDefault, onClick, disabled, ...props }) {
    const [last4Digits, setLast4Digits] = useState('');
    const [cardOperator, setCardOperator] = useState('null');

    const getCardOperator = (cardNumber) => {
        const number = cardNumber.replace(/\D/g, ''); // Remove non-digit characters

        // Accepted brands first
        if (/^4/.test(number)) {
            return 'visa';
        } else if (/^(5[1-5]|2221|2222|2223|2224|2225|2226|2227|2228|2229|223|224|225|226|227|228|229|23|24|25|26|270|271|2720)/.test(number)) {
            return 'mastercard';
        } else if (/^3[47]/.test(number)) {
            return 'amex';
        } else if (/^(401178|401179|438935|457631|457632|431274|451416|457393|504175|5066[8-9][0-9]{2}|5090[0-9]{3}|627780|6362[7-9]|636368|65(0031|0032|0033|0035|0051)|6504[0-3]|65048[5-8]|6505[3-8]|65054[1-8]|6505[4-9]|6507[0-8]|65072[0-7]|6509[0-7][0-9]|65098[0-8]|6516[5-9]|6517[0-9]|6550[0-1]|65502[1-8])/.test(number)) {
            return 'elo';
        } else if (/^606282/.test(number)) {
            return 'hipercard';
        } 
        
        // Non-accepted brands
        else if (/^(6011|64[4-9]|65)/.test(number)) {
            return 'discover';
        } else if (/^(30[0-5]|36|38|39)/.test(number)) {
            return 'diners';
        } else if (/^(35(28|29|30|31|32|33|34|35|36|37|38|39)|2131|1800)/.test(number)) {
            return 'jcb';
        } else if (/^(620|624|626|62100|62101|62102|62103|62104|62105|62106|62107|62108|62109|6211[0-9]{2}|6218[4-7]|62185|62186|62187|6220[0-5]|62201[0-9]{1,3}|622018|622019|622[0-9]{2}|6220[7-9]|6221[2-5][0-9]{2}|623|624|625|626|6270|6272|6276|6277[0-9]{2}|62778[1-9]|6277[8-9][0-9]|628[2-9]|629[1-2]|810|8110|8131|8132|8151|8152|8163|8164|8171)/.test(number)) {
            return 'unionpay';
        } else if (/^220[0-4]/.test(number)) {
            return 'mir';
        } else if (/^(637095|637568|637599|637609|637612|63743358|63737423)/.test(number)) {
            return 'hiper';
        } else {
            return 'null';
        }
    };

    const getLast4Digits = (cardNumber) => {
        const digitsOnly = cardNumber.replace(/\D/g, ''); // Remove non-digit characters
        return digitsOnly.slice(-4); // Get the last 4 digits
    };

    useEffect(() => {
        setLast4Digits(getLast4Digits(cardNumber));
        setCardOperator(getCardOperator(cardNumber));
    }, [cardNumber]);

    return (
        <>
            {!disabled 
                ?
                    <div 
                        className={`row defaultBorderedItem clickArea ${isSelected ? 'selectedItem' : 'itemSelect'}`} 
                        onClick={onClick} 
                        style={{ gap: '10px', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                        <div className='row' style={{ alignItems: 'center', gap: '10px' }}>
                            <span><span className='grayedText'>•••• </span>{last4Digits}</span>
                            {cardOperator !== 'null'
                            ? 
                                <img src={cardOperatorLogos[cardOperator]} alt={`${cardOperator} logo`} style={{height: '24px'}}/>
                            :
                                <CreditCard style={{color: 'gray'}}/>
                            }
                        </div>
                        {isDefault &&
                            <span>Padrão</span>
                        }
                        <div className='row center'>
                            <Edit/>
                            <span>Alterar</span>
                        </div>
                    </div>
                :
                <div 
                    className='row defaultBorderedItem' 
                    style={{ gap: '10px', justifyContent: 'space-between', alignItems: 'center' }}
                >
                    <div className='row' style={{ alignItems: 'center', gap: '10px' }}>
                        <span><span className='grayedText'>•••• </span>{last4Digits}</span>
                        {cardOperator !== 'null'
                        ? 
                            <img src={cardOperatorLogos[cardOperator]} alt={`${cardOperator} logo`} style={{height: '24px'}}/>
                        :
                            <CreditCard style={{color: 'gray'}}/>
                        }
                    </div>
                    {isDefault &&
                        <span>Padrão</span>
                    }
                </div>
            }
        </>
    );
}

CardTile.propTypes = {
    cardNumber: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default CardTile;